<template>
  <div>
    <h1 class="display-heading">Health Savvy Membership</h1>

    <div class="mb-3">
      <div class="health-savvy-card">
        <img
          src="/static/images/virtual-card/Digital-Card-BG2-690x405.png"
          alt=""
          class="card-background"
        />
        <div class="health-savvy-overlay">
          <div>
            <div class="customer-name">{{ cardHolderName }}</div>
            <div class="customer-identity-card">{{ cardHolderIdentityCardNumber }}</div>
            <div class="customer-email-address">{{ cardHolderEmailAddress }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-5">
      <a
        class="btn btn-primary btn-primary-insv"
        :href="downloadUrl"
        target="_blank"
        >Download My Member Card</a
      >
    </div>

    <health-savvy-member-benefit></health-savvy-member-benefit>
  </div>
</template>

<script>
import { apiPath } from '@/config';
import Cookies from 'js-cookie';
import HealthSavvyMemberBenefit from '@/components/health-savvy-member-benefit';

export default {
    'name': 'HealthSavvyMembership',
    'components': {
        HealthSavvyMemberBenefit
    },
    data () {
        return {
            apiPath,
            'cardHolderName': '',
            'cardHolderIdentityCardNumber': '',
            'cardHolderEmailAddress': ''
        };
    },
    'computed': {
        token () {
            return Cookies.get('t');
        },
        downloadUrl () {
            return `${apiPath}VirtualCard/Download?token=${this.token}`;
        }
    },
    mounted () {
        this.getProfile();
    },
    'methods': {
        getProfile () {
            this.axios.get('Profile/GetUserProfile').then(({ data }) => {
                this.cardHolderName = data.data.f;
                this.cardHolderEmailAddress = data.data.e.toLowerCase();
                this.cardHolderIdentityCardNumber = data.data.ic;
            });
        }
    }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");
.health-savvy-card {
  position: relative;
  max-width: 460px;
  height: 270px;
  margin-bottom: 30px;
  filter: drop-shadow(5px 5px 10px #cecece);
  font-family: "Roboto", sans-serif;
  line-height: 1.2;
}

.health-savvy-card img {
  width: 100%;
}

.health-savvy-card .health-savvy-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 25px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: right;
  text-align: right;
  font-weight: bold;
}

.health-savvy-card .health-savvy-overlay > div {
  width: 100%;
  margin-bottom: 40px;
}

.health-savvy-card .health-savvy-overlay .customer-name {
  font-size: 22px;
  text-transform: uppercase;
}

.health-savvy-card .health-savvy-overlay .customer-identity-card {
  font-size: 16px;
  color: #636667;
}

.health-savvy-card .health-savvy-overlay .customer-email-address {
  font-size: 16px;
  color: #636667;
}
</style>
